export default "__VITE_ASSET__40dc9f72__"